import { render, staticRenderFns } from "./filePreviewer.vue?vue&type=template&id=41405014&scoped=true"
import script from "./filePreviewer.vue?vue&type=script&lang=js"
export * from "./filePreviewer.vue?vue&type=script&lang=js"
import style0 from "./filePreviewer.vue?vue&type=style&index=0&id=41405014&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41405014",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\G\\YT\\mes-project-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('41405014')) {
      api.createRecord('41405014', component.options)
    } else {
      api.reload('41405014', component.options)
    }
    module.hot.accept("./filePreviewer.vue?vue&type=template&id=41405014&scoped=true", function () {
      api.rerender('41405014', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/wl-business-component/sopComponents/pageFileView/filePreviewer.vue"
export default component.exports